import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './Tag.module.css';

export default class Tag extends React.PureComponent {
    static propTypes = {
        id: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]).isRequired,
        caption: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node,
        ]).isRequired,
        type: PropTypes.oneOf(['light', 'lesta', 'blue', 'warning', 'yellow']), // 'light', 'warning', 'yellow', 'blue'
        isChecked: PropTypes.bool,
        isError: PropTypes.bool,
        isDisabled: PropTypes.bool,

        isSupport: PropTypes.bool, // tag on the support page

        onClick: PropTypes.func.isRequired,
    }

    handleClick = (event) => {
        event.preventDefault()
        event.stopPropagation()
        this.props.onClick(this.props.id)
    }

    render() {
        const classNameBase = classNames(styles.base, {
            [styles.isChecked]: this.props.isChecked,
            [styles.isError]: this.props.isError,
            [styles.isDisabled]: this.props.isDisabled,
            [styles.isSupport]: this.props.isSupport,
            [styles.isReport]: this.props.isReport,
            [styles[`base__${this.props.type}`]]: this.props.type,
        })

        return (
            <div className={classNameBase} onClick={this.handleClick}>
                <div className={styles.caption}>
                    {this.props.caption}
                </div>
                {/* <span className={classNames(styles.hole, styles[`hole__left`])} /> */}
                {/* <span className={classNames(styles.hole, styles[`hole__right`])} /> */}
            </div>
        )
    }
}
